const Button = ({
  children,
  type = "button",
  variant = "primary",
  size = "medium",
  loading = false,
  disabled = false,
  icon = null,
  className = "",
  ...props
}) => {
  const classes = [
    "app-button",
    `app-button-${variant}`,
    `app-button-${size}`,
    className,
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <button
      type={type}
      className={classes}
      disabled={
        disabled ||
        loading
      }
      {...props}
    >
      {icon && (
        <span className="app-button-icon">
          {icon}
        </span>
      )}

      <span>
        {loading
          ? "Please wait..."
          : children}
      </span>
    </button>
  );
};

export default Button;